import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TextIncreaseIcon(props: IconProps) {
    return <Icon {...props} iconKey={"text_increase"}/>
}
